(function(){
    'use strict'; 
    angular.module('Services').factory('ServiceRequestTicketService', ServiceRequestTicketService);
    ServiceRequestTicketService.$inject = ['Request'];
    function ServiceRequestTicketService(Request) {
        return {
            getAll: (successCallback, errorCallback, data) => {
                Request.get({
                    url: ApiURLs.serviceRequestTicket.ticketing,
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    data: data
                });
            },
             getTicketLogs: (ticketId,successCallback, errorCallback) => {
                const url = ApiURLs.serviceRequestTicket.ticketLogs.replace(':ticketId',ticketId)
                Request.get({
                    url: url,
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                });
            },
            ticketDetails:(id,successCallback,errorCallback)=>{
                const url = `${ApiURLs.serviceRequestTicket.ticketing}/${id}`;
                 Request.get({
                    url: url,
                    successCallback: successCallback,
                    errorCallback: errorCallback
                });
            },
            create: (successCallback, errorCallback, payload) => {
                Request.post({
                    method: 'POST',
                    url: ApiURLs.serviceRequestTicket.create,
                    successCallback: successCallback,
                    errorCallback: errorCallback
                }, payload);
            },
            comment:(ticketId,successCallback, errorCallback)=>{
                const url = ApiURLs.serviceRequestTicket.comment.replace(':ticketId',ticketId);
                 Request.get({
                    url: url,
                    successCallback: successCallback,
                    errorCallback: errorCallback
                });
            },
            newComment:(ticketId,successCallback,errorCallback,payload)=>{
                const url = ApiURLs.serviceRequestTicket.comment.replace(':ticketId',ticketId);
                 Request.post({
                    url: url,
                    method:'POST',
                    successCallback: successCallback,
                    errorCallback: errorCallback
                },payload);
            },
            assignUser:(ticketId, successCallback, errorCallback)=>{
                const url = ApiURLs.serviceRequestTicket.assignUser.replace(':ticketId',ticketId)
                Request.post({
                     url: url,
                    method:'POST',
                    successCallback: successCallback,
                    errorCallback: errorCallback
                });
            },
            updateTicketStatus:(ticketId, successCallback, errorCallback,payload)=>{
                const url = ApiURLs.serviceRequestTicket.updateStatus.replace(':ticketId',ticketId)
                Request.post({
                    url: url,
                    method:'PATCH',
                    successCallback: successCallback,
                    errorCallback: errorCallback
                },payload);
            },
            export: (successCallback, errorCallback) => {
               Request.downloadFile({
                    fileName: `ticket-report.csv`,
                    method: 'POST',
                    url: ApiURLs.serviceRequestTicket.export,
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    fileType: 'text/csv',
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: 'text/csv'
                    }
                });
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/ServiceRequestTicketService.js